import { render, staticRenderFns } from "./GoogleBusinessChannelDetail.vue?vue&type=template&id=bca9f116&scoped=true"
import script from "./GoogleBusinessChannelDetail.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessChannelDetail.vue?vue&type=style&index=0&id=bca9f116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca9f116",
  null
  
)

export default component.exports